import { useState, useRef, useEffect } from "react";
import styles from "./styles.module.scss";
import LandingHeader from "component/Common/LandingHeader";
import LandingFooter from "component/Common/LandingFooter";
import ScrollContext from "context/scrollContext";

export const LandingLayout = (props) => {
  const appDemoScrollRef = useRef();
  const landingHeaderRef = useRef();
  const [shouldScroll, setShouldScroll] = useState(false);

  // On initial mount, check sessionStorage and set state
  useEffect(() => {
    if (sessionStorage.getItem("scrollToTarget")) {
      sessionStorage.removeItem("scrollToTarget");
      setShouldScroll(true);
    }
  }, []);

  // Watch for scrollRef being assigned AND scroll intent being true
  useEffect(() => {
    if (shouldScroll) {
      const interval = setInterval(() => {
        if (appDemoScrollRef.current) {
          handleScroll();
          setShouldScroll(false);
          clearInterval(interval);
        }
      }, 50);
      return () => clearInterval(interval);
    }
  }, [shouldScroll]);

  // reactively waits for ref

  const handleScroll = () => {
    appDemoScrollRef?.current?.scrollToTarget(); // calling child method
  };

  return (
    <ScrollContext.Provider value={{ appDemoScrollRef, handleScroll }}>
      <div className="w-full m-0">
        <LandingHeader handleScroll={handleScroll} landingHeaderRef={landingHeaderRef} />
        <div className={styles.container}>{props.children}</div>
        <LandingFooter />
      </div>
    </ScrollContext.Provider>
  );
};
